
import { mapGetters } from 'vuex'
import FilterToggle from './ui/filter-toggle.vue'
import FilterDropdown from './ui/filter-dropdown.vue'
import FilterColor from './filter-color'
import FilterSize from './filter-size'
import FilterPrices from './filter-prices'
import FilterCheckbox from './filter-checkbox'
import FilterSortby from './filter-sortby'
import FilterAllFilters from './filter-allfilters'
import FilterReset from './filter-reset'

export default {
  components: {
    FilterToggle,
    FilterDropdown,
    FilterColor,
    FilterSize,
    FilterPrices,
    FilterCheckbox,
    FilterSortby,
    FilterAllFilters,
    FilterReset,
  },
  props: {
    searchResults: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allFiltersModal: false,
      openedDropdown: null,
      selectedSortingOption: null,
    }
  },
  computed: {
    ...mapGetters({
      vxStoryContent: 'search/getStoryContent',
      vxSearchParams: 'search/getSearchParameters',
      vxActivePriceFacets: 'search/getActivePriceFacets',
      vxCurrency: 'currency/getCurrency',
    }),
    filterFacets() {
      const tmpSearchResults = this.searchResults
      return tmpSearchResults.facets.sort((a, b) =>
        a.label.localeCompare(b.label)
      )
    },
    basicFilterFacets() {
      const sortOrder = {
        ss_final_price: 0,
        ss_normalize_color: 1,
        variant_size: 2,
        tags_en_facet_natural_fibers_filter: 3,
        ss_on_sale: 4,
      }

      // return only facets in the sort order by sort order
      return this.filterFacets
        .filter(({ field }) => sortOrder?.[field] >= 0)
        .sort((a, b) => sortOrder[a.field] - sortOrder[b.field])
    },
    sizeFacets() {
      const facets = this?.filterFacets?.find(
        ({ field }) => field === 'variant_size'
      )?.values

      const osFilterIndex = facets.findIndex(
        ({ value }) => value.toUpperCase() === 'O/S'
      )
      if (osFilterIndex !== -1) {
        const osFilter = facets.splice(osFilterIndex, 1)[0]
        facets.push(osFilter)
      }
      return facets
    },
    priceFacets() {
      let facetField = 'ss_final_price'
      if (this.vxCurrency === 'CAD') facetField = 'ss_price_ca'
      if (this.vxCurrency === 'EUR') facetField = 'ss_price_eu'
      return this?.filterFacets?.find(({ field }) => field === facetField)
        ?.values
    },
  },
  methods: {
    getActiveFiltersCount(facet) {
      if (facet.field === 'ss_final_price') {
        return this.vxActivePriceFacets.length
      } else {
        return facet?.values?.filter(({ active }) => active)?.length
      }
    },
    getAllFiltersCount() {
      return this?.filterFacets?.reduce((acc, facet) => {
        return acc + this.getActiveFiltersCount(facet)
      }, 0)
    },
    openFiltersModal() {
      this.allFiltersModal = true
    },
    closeFiltersModal() {
      this.allFiltersModal = false
    },
    setOpenedDropdown(filterField) {
      this.openedDropdown = filterField
    },
    setSortby(sortingOption) {
      this.selectedSortingOption = sortingOption
      this.openedDropdown = null
    },
  },
}
